// extracted by mini-css-extract-plugin
export default {"issueNumberText":"IssuePicker-module__issueNumberText__Yoag4C5"};